import type { FirstClassDocument } from '../../types';
import parseDate from './parseDate';

export default function parsePublishedDate(
  publishedDate: NonNullable<FirstClassDocument['published_date']>,
): ReturnType<typeof parseDate> {
  return parseDate(publishedDate, 'yyyy-MM-dd');
}
